<template>
  <el-dialog title="重新申请" width="30%" :visible.sync="diaVisible" append-to-body @close="handleClose()">
    <el-form :model="form" label-width="100px" ref="form" style="padding-right: 20px">
      <el-form-item label="客户名称:" prop="name">
        <el-input v-model="form.name" placeholder="请根据驳回原因进行修改，无误则不填该项"></el-input>
      </el-form-item>
      <el-form-item label="父级机构编码:" prop="parentOrgCode">
        <el-input v-model="form.parentOrgCode" placeholder="请根据驳回原因进行修改，无父级则不填该项"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="handleClose()">
      </crm-button>
      <crm-button :text="'确定'" @click="handleSubmit()"></crm-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import CrmButton from '@/components/base/crmButton';

export default {
  components: {
    CrmButton,
  },
  props: {
    uid: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      diaVisible: false,
      form: {
        uid: this.uid,
        name: null,
        parentOrgCode: null,
      },
    };
  },
  watch: {
    visible(val) {
      this.diaVisible = val;
    },
  },
  methods: {
    ...mapActions({
      replyAgain: 'customer/replyAgain',
    }),
    handleSubmit() {
      if (!this.form.name && !this.form.parentOrgCode) {
        this.$message.error('未填写内容！');
        return;
      }
      this.form.uid = this.uid;
      this.replyAgain(this.form).then(() => {
        this.$message.success('已重新申请');
        this.handleClose();
        this.$emit('success');
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
      this.$emit('close');
    },
  },
};
</script>

<style>

</style>
